"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[808],{

/***/ 76043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const FormControlContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(undefined);
/* harmony default export */ __webpack_exports__["Z"] = (FormControlContext);

/***/ }),

/***/ 39224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FormHelperText_FormHelperText; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useForkRef.js
var useForkRef = __webpack_require__(30067);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/base/utils/useSlotProps.js
var useSlotProps = __webpack_require__(7293);
// EXTERNAL MODULE: ./node_modules/@mui/joy/styles/styled.js + 1 modules
var styled = __webpack_require__(58609);
// EXTERNAL MODULE: ./node_modules/@mui/joy/styles/useThemeProps.js
var useThemeProps = __webpack_require__(20407);
// EXTERNAL MODULE: ./node_modules/@mui/joy/className/index.js
var className = __webpack_require__(26821);
;// CONCATENATED MODULE: ./node_modules/@mui/joy/FormHelperText/formHelperTextClasses.js

function getFormHelperTextUtilityClass(slot) {
  return (0,className/* generateUtilityClass */.d6)('JoyFormHelperText', slot);
}
const formHelperTextClasses = (0,className/* generateUtilityClasses */.sI)('JoyFormHelperText', ['root']);
/* harmony default export */ var FormHelperText_formHelperTextClasses = ((/* unused pure expression or super */ null && (formHelperTextClasses)));
// EXTERNAL MODULE: ./node_modules/@mui/joy/FormControl/FormControlContext.js
var FormControlContext = __webpack_require__(76043);
// EXTERNAL MODULE: ./node_modules/@mui/joy/FormLabel/formLabelClasses.js
var formLabelClasses = __webpack_require__(16931);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/joy/FormHelperText/FormHelperText.js


const _excluded = ["children", "component"];










const useUtilityClasses = () => {
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getFormHelperTextUtilityClass, {});
};
const FormHelperTextRoot = (0,styled/* default */.Z)('p', {
  name: 'JoyFormHelperText',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  fontFamily: theme.vars.fontFamily.body,
  fontSize: `var(--FormHelperText-fontSize, ${theme.vars.fontSize.sm})`,
  lineHeight: theme.vars.lineHeight.sm,
  color: `var(--FormHelperText-color, ${theme.vars.palette.text.secondary})`,
  margin: 'var(--FormHelperText-margin, 0px)',
  [`.${formLabelClasses/* default.root */.Z.root} + &`]: {
    '--FormHelperText-margin': '0px' // remove the margin if the helper text is next to the form label.
  }
}));

const FormHelperText = /*#__PURE__*/react.forwardRef(function FormHelperText(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'JoyFormHelperText'
  });
  const {
      children,
      component
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const rootRef = react.useRef(null);
  const handleRef = (0,useForkRef/* default */.Z)(rootRef, ref);
  const formControl = react.useContext(FormControlContext/* default */.Z);
  const setHelperText = formControl == null ? void 0 : formControl.setHelperText;
  react.useEffect(() => {
    setHelperText == null ? void 0 : setHelperText(rootRef.current);
    return () => {
      setHelperText == null ? void 0 : setHelperText(null);
    };
  }, [setHelperText]);
  const ownerState = (0,esm_extends/* default */.Z)({}, props);
  const classes = useUtilityClasses();
  const rootProps = (0,useSlotProps/* default */.Z)({
    elementType: FormHelperTextRoot,
    externalSlotProps: {},
    externalForwardedProps: other,
    ownerState,
    additionalProps: {
      ref: handleRef,
      as: component,
      id: formControl == null ? void 0 : formControl['aria-describedby']
    },
    className: classes.root
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FormHelperTextRoot, (0,esm_extends/* default */.Z)({}, rootProps, {
    children: children
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var FormHelperText_FormHelperText = (FormHelperText);

/***/ }),

/***/ 26967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63366);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_base_composeClasses__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94780);
/* harmony import */ var _mui_base_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7293);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58609);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20407);
/* harmony import */ var _formLabelClasses__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16931);
/* harmony import */ var _FormControl_FormControlContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76043);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


const _excluded = ["children", "component", "componentsProps"];








const useUtilityClasses = () => {
  const slots = {
    root: ['root'],
    asterisk: ['asterisk']
  };
  return (0,_mui_base_composeClasses__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(slots, _formLabelClasses__WEBPACK_IMPORTED_MODULE_3__/* .getFormLabelUtilityClass */ .B, {});
};
const FormLabelRoot = (0,_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)('label', {
  name: 'JoyFormLabel',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(({
  theme
}) => ({
  WebkitTapHighlightColor: 'transparent',
  alignSelf: 'var(--FormLabel-alignSelf)',
  // to not fill the block space. It seems like a bug when clicking on empty space (within the label area), even though it is not.
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  userSelect: 'none',
  fontFamily: theme.vars.fontFamily.body,
  fontSize: `var(--FormLabel-fontSize, ${theme.vars.fontSize.sm})`,
  fontWeight: theme.vars.fontWeight.md,
  lineHeight: theme.vars.lineHeight.md,
  color: `var(--FormLabel-color, ${theme.vars.palette.text.primary})`,
  margin: 'var(--FormLabel-margin, 0px)'
}));
const AsteriskComponent = (0,_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)('span', {
  name: 'JoyFormLabel',
  slot: 'Asterisk',
  overridesResolver: (props, styles) => styles.asterisk
})({
  color: 'var(--FormLabel-asterisk-color)'
});
const FormLabel = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function FormLabel(inProps, ref) {
  var _ref, _inProps$required;
  const props = (0,_styles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    props: inProps,
    name: 'JoyFormLabel'
  });
  const {
      children,
      component = 'label',
      componentsProps = {}
    } = props,
    other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(props, _excluded);
  const formControl = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_FormControl_FormControlContext__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z);
  const required = (_ref = (_inProps$required = inProps.required) != null ? _inProps$required : formControl == null ? void 0 : formControl.required) != null ? _ref : false;
  const ownerState = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props, {
    required
  });
  const classes = useUtilityClasses();
  const rootProps = (0,_mui_base_utils__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
    elementType: FormLabelRoot,
    externalSlotProps: componentsProps.root,
    externalForwardedProps: other,
    ownerState,
    additionalProps: {
      ref,
      as: component,
      htmlFor: formControl == null ? void 0 : formControl.htmlFor,
      id: formControl == null ? void 0 : formControl.labelId
    },
    className: classes.root
  });
  const asteriskProps = (0,_mui_base_utils__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
    elementType: AsteriskComponent,
    externalSlotProps: componentsProps.asterisk,
    ownerState,
    additionalProps: {
      'aria-hidden': true
    },
    className: classes.asterisk
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FormLabelRoot, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, rootProps, {
    children: [children, required && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(AsteriskComponent, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, asteriskProps, {
      children: ["\u2009", '*']
    }))]
  }));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (FormLabel);

/***/ }),

/***/ 16931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ getFormLabelUtilityClass; }
/* harmony export */ });
/* harmony import */ var _className__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26821);

function getFormLabelUtilityClass(slot) {
  return (0,_className__WEBPACK_IMPORTED_MODULE_0__/* .generateUtilityClass */ .d6)('JoyFormLabel', slot);
}
const formLabelClasses = (0,_className__WEBPACK_IMPORTED_MODULE_0__/* .generateUtilityClasses */ .sI)('JoyFormLabel', ['root', 'asterisk']);
/* harmony default export */ __webpack_exports__["Z"] = (formLabelClasses);

/***/ }),

/***/ 69392:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "TB": function() { return /* binding */ StyledInputEndDecorator; },
  "MK": function() { return /* binding */ StyledInputHtml; },
  "kx": function() { return /* binding */ StyledInputRoot; },
  "h_": function() { return /* binding */ StyledInputStartDecorator; },
  "ZP": function() { return /* binding */ Input_Input; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/capitalize.js
var capitalize = __webpack_require__(28320);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/base/utils/useSlotProps.js
var useSlotProps = __webpack_require__(7293);
// EXTERNAL MODULE: ./node_modules/@mui/joy/styles/styled.js + 1 modules
var styled = __webpack_require__(58609);
// EXTERNAL MODULE: ./node_modules/@mui/joy/styles/useThemeProps.js
var useThemeProps = __webpack_require__(20407);
// EXTERNAL MODULE: ./node_modules/@mui/joy/className/index.js
var className = __webpack_require__(26821);
;// CONCATENATED MODULE: ./node_modules/@mui/joy/Input/inputClasses.js

function getInputUtilityClass(slot) {
  return (0,className/* generateUtilityClass */.d6)('JoyInput', slot);
}
const inputClasses = (0,className/* generateUtilityClasses */.sI)('JoyInput', ['root', 'input', 'formControl', 'focused', 'disabled', 'error', 'adornedStart', 'adornedEnd', 'colorPrimary', 'colorNeutral', 'colorDanger', 'colorInfo', 'colorSuccess', 'colorWarning', 'sizeSm', 'sizeMd', 'sizeLg', 'variantPlain', 'variantOutlined', 'variantSoft', 'variantSolid', 'fullWidth', 'startDecorator', 'endDecorator']);
/* harmony default export */ var Input_inputClasses = (inputClasses);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/formatMuiErrorMessage.js
var formatMuiErrorMessage = __webpack_require__(71387);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useForkRef.js
var useForkRef = __webpack_require__(30067);
;// CONCATENATED MODULE: ./node_modules/@mui/base/FormControlUnstyled/FormControlUnstyledContext.js

/**
 * @ignore - internal component.
 */
const FormControlUnstyledContext = /*#__PURE__*/react.createContext(undefined);
if (false) {}
/* harmony default export */ var FormControlUnstyled_FormControlUnstyledContext = (FormControlUnstyledContext);
;// CONCATENATED MODULE: ./node_modules/@mui/base/FormControlUnstyled/useFormControlUnstyledContext.js


function useFormControlUnstyledContext() {
  return react.useContext(FormControlUnstyled_FormControlUnstyledContext);
}
// EXTERNAL MODULE: ./node_modules/@mui/base/utils/extractEventHandlers.js
var extractEventHandlers = __webpack_require__(30437);
;// CONCATENATED MODULE: ./node_modules/@mui/base/InputUnstyled/useInput.js






function useInput(parameters) {
  const {
    defaultValue: defaultValueProp,
    disabled: disabledProp = false,
    error: errorProp = false,
    onBlur,
    onChange,
    onFocus,
    required: requiredProp = false,
    value: valueProp
  } = parameters;
  const formControlContext = useFormControlUnstyledContext();
  let defaultValue;
  let disabled;
  let error;
  let required;
  let value;
  if (formControlContext) {
    var _formControlContext$d, _formControlContext$e, _formControlContext$r;
    defaultValue = undefined;
    disabled = (_formControlContext$d = formControlContext.disabled) != null ? _formControlContext$d : false;
    error = (_formControlContext$e = formControlContext.error) != null ? _formControlContext$e : false;
    required = (_formControlContext$r = formControlContext.required) != null ? _formControlContext$r : false;
    value = formControlContext.value;
    if (false) {}
  } else {
    defaultValue = defaultValueProp;
    disabled = disabledProp;
    error = errorProp;
    required = requiredProp;
    value = valueProp;
  }
  const {
    current: isControlled
  } = react.useRef(value != null);
  const handleInputRefWarning = react.useCallback(instance => {
    if (false) {}
  }, []);
  const inputRef = react.useRef(null);
  const handleInputRef = (0,useForkRef/* default */.Z)(inputRef, handleInputRefWarning);
  const [focused, setFocused] = react.useState(false);

  // The blur won't fire when the disabled state is set on a focused input.
  // We need to book keep the focused state manually.
  react.useEffect(() => {
    if (!formControlContext && disabled && focused) {
      setFocused(false);

      // @ts-ignore
      onBlur == null ? void 0 : onBlur();
    }
  }, [formControlContext, disabled, focused, onBlur]);
  const handleFocus = otherHandlers => event => {
    var _otherHandlers$onFocu;
    // Fix a bug with IE11 where the focus/blur events are triggered
    // while the component is disabled.
    if (formControlContext != null && formControlContext.disabled) {
      event.stopPropagation();
      return;
    }
    (_otherHandlers$onFocu = otherHandlers.onFocus) == null ? void 0 : _otherHandlers$onFocu.call(otherHandlers, event);
    if (formControlContext && formControlContext.onFocus) {
      var _formControlContext$o;
      formControlContext == null ? void 0 : (_formControlContext$o = formControlContext.onFocus) == null ? void 0 : _formControlContext$o.call(formControlContext);
    } else {
      setFocused(true);
    }
  };
  const handleBlur = otherHandlers => event => {
    var _otherHandlers$onBlur;
    (_otherHandlers$onBlur = otherHandlers.onBlur) == null ? void 0 : _otherHandlers$onBlur.call(otherHandlers, event);
    if (formControlContext && formControlContext.onBlur) {
      formControlContext.onBlur();
    } else {
      setFocused(false);
    }
  };
  const handleChange = otherHandlers => (event, ...args) => {
    var _formControlContext$o2, _otherHandlers$onChan;
    if (!isControlled) {
      const element = event.target || inputRef.current;
      if (element == null) {
        throw new Error( false ? 0 : (0,formatMuiErrorMessage/* default */.Z)(17));
      }
    }
    formControlContext == null ? void 0 : (_formControlContext$o2 = formControlContext.onChange) == null ? void 0 : _formControlContext$o2.call(formControlContext, event);

    // @ts-ignore
    (_otherHandlers$onChan = otherHandlers.onChange) == null ? void 0 : _otherHandlers$onChan.call(otherHandlers, event, ...args);
  };
  const handleClick = otherHandlers => event => {
    var _otherHandlers$onClic;
    if (inputRef.current && event.currentTarget === event.target) {
      inputRef.current.focus();
    }
    (_otherHandlers$onClic = otherHandlers.onClick) == null ? void 0 : _otherHandlers$onClic.call(otherHandlers, event);
  };
  const getRootProps = (externalProps = {}) => {
    // onBlur, onChange and onFocus are forwarded to the input slot.
    const propsEventHandlers = (0,extractEventHandlers/* default */.Z)(parameters, ['onBlur', 'onChange', 'onFocus']);
    const externalEventHandlers = (0,esm_extends/* default */.Z)({}, propsEventHandlers, (0,extractEventHandlers/* default */.Z)(externalProps));
    return (0,esm_extends/* default */.Z)({}, externalProps, externalEventHandlers, {
      onClick: handleClick(externalEventHandlers)
    });
  };
  const getInputProps = (externalProps = {}) => {
    const propsEventHandlers = {
      onBlur,
      onChange,
      onFocus
    };
    const externalEventHandlers = (0,esm_extends/* default */.Z)({}, propsEventHandlers, (0,extractEventHandlers/* default */.Z)(externalProps));
    const mergedEventHandlers = (0,esm_extends/* default */.Z)({}, externalProps, externalEventHandlers, {
      onBlur: handleBlur(externalEventHandlers),
      onChange: handleChange(externalEventHandlers),
      onFocus: handleFocus(externalEventHandlers)
    });
    return (0,esm_extends/* default */.Z)({}, mergedEventHandlers, {
      'aria-invalid': error || undefined,
      defaultValue: defaultValue,
      ref: handleInputRef,
      value: value,
      required,
      disabled
    });
  };
  return {
    disabled,
    error,
    focused,
    formControlContext,
    getInputProps,
    getRootProps,
    required,
    value
  };
}
// EXTERNAL MODULE: ./node_modules/@mui/joy/FormControl/FormControlContext.js
var FormControlContext = __webpack_require__(76043);
;// CONCATENATED MODULE: ./node_modules/@mui/joy/Input/useForwardedInput.js


const _excluded = ["aria-describedby", "aria-label", "aria-labelledby", "autoComplete", "autoFocus", "className", "defaultValue", "disabled", "error", "id", "name", "onClick", "onChange", "onKeyDown", "onKeyUp", "onFocus", "onBlur", "placeholder", "readOnly", "required", "type", "value"];



function useForwardedInput(props, classes) {
  const formControl = react.useContext(FormControlContext/* default */.Z);
  const {
      'aria-describedby': ariaDescribedby,
      'aria-label': ariaLabel,
      'aria-labelledby': ariaLabelledby,
      autoComplete,
      autoFocus,
      className,
      defaultValue,
      disabled: disabledProp,
      error: errorProp,
      id,
      name,
      onClick,
      onChange,
      onKeyDown,
      onKeyUp,
      onFocus,
      onBlur,
      placeholder,
      readOnly,
      required,
      type,
      value
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const {
    getRootProps,
    getInputProps,
    focused,
    error,
    disabled
  } = useInput({
    disabled: disabledProp != null ? disabledProp : formControl == null ? void 0 : formControl.disabled,
    defaultValue,
    error: errorProp,
    onBlur,
    onClick,
    onChange,
    onFocus,
    required,
    value
  });
  const rootStateClasses = {
    [classes.disabled]: disabled,
    [classes.error]: error,
    [classes.focused]: focused,
    [classes.formControl]: Boolean(formControl),
    [className]: className
  };
  const inputStateClasses = {
    [classes.disabled]: disabled
  };
  const propsToForward = {
    'aria-describedby': ariaDescribedby,
    'aria-label': ariaLabel,
    'aria-labelledby': ariaLabelledby,
    autoComplete,
    autoFocus,
    disabled,
    id,
    onKeyDown,
    onKeyUp,
    name,
    placeholder,
    readOnly,
    type
  };
  return (0,esm_extends/* default */.Z)({
    formControl,
    propsToForward,
    rootStateClasses,
    inputStateClasses,
    getRootProps,
    getInputProps,
    focused,
    error,
    disabled
  }, other);
}
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/joy/Input/Input.js


const Input_excluded = ["propsToForward", "rootStateClasses", "inputStateClasses", "getRootProps", "getInputProps", "component", "componentsProps", "formControl", "focused", "error", "disabled", "fullWidth", "size", "color", "variant", "startDecorator", "endDecorator"];










const useUtilityClasses = ownerState => {
  const {
    disabled,
    fullWidth,
    variant,
    color,
    size
  } = ownerState;
  const slots = {
    root: ['root', disabled && 'disabled', fullWidth && 'fullWidth', variant && `variant${(0,capitalize/* default */.Z)(variant)}`, color && `color${(0,capitalize/* default */.Z)(color)}`, size && `size${(0,capitalize/* default */.Z)(size)}`],
    input: ['input'],
    startDecorator: ['startDecorator'],
    endDecorator: ['endDecorator']
  };
  return (0,composeClasses/* default */.Z)(slots, getInputUtilityClass, {});
};
const StyledInputRoot = (0,styled/* default */.Z)('div')(({
  theme,
  ownerState
}) => {
  var _theme$variants, _theme$vars$palette, _variantStyle$backgro, _theme$variants2, _theme$variants3;
  const variantStyle = (_theme$variants = theme.variants[`${ownerState.variant}`]) == null ? void 0 : _theme$variants[ownerState.color];
  return [(0,esm_extends/* default */.Z)({
    '--Input-radius': theme.vars.radius.sm,
    '--Input-gap': '0.5rem',
    '--Input-placeholderColor': 'inherit',
    '--Input-placeholderOpacity': 0.5,
    '--Input-focusedThickness': theme.vars.focus.thickness
  }, ownerState.color === 'context' ? {
    '--Input-focusedHighlight': theme.vars.palette.focusVisible
  } : {
    '--Input-focusedHighlight': (_theme$vars$palette = theme.vars.palette[ownerState.color === 'neutral' ? 'primary' : ownerState.color]) == null ? void 0 : _theme$vars$palette[500]
  }, ownerState.size === 'sm' && {
    '--Input-minHeight': '2rem',
    '--Input-paddingInline': '0.5rem',
    '--Input-decorator-childHeight': 'min(1.5rem, var(--Input-minHeight))',
    '--Icon-fontSize': '1.25rem'
  }, ownerState.size === 'md' && {
    '--Input-minHeight': '2.5rem',
    '--Input-paddingInline': '0.75rem',
    '--Input-decorator-childHeight': 'min(2rem, var(--Input-minHeight))',
    '--Icon-fontSize': '1.5rem'
  }, ownerState.size === 'lg' && {
    '--Input-minHeight': '3rem',
    '--Input-paddingInline': '1rem',
    '--Input-gap': '0.75rem',
    '--Input-decorator-childHeight': 'min(2.375rem, var(--Input-minHeight))',
    '--Icon-fontSize': '1.75rem'
  }, {
    // variables for controlling child components
    '--Input-decorator-childOffset': 'min(calc(var(--Input-paddingInline) - (var(--Input-minHeight) - 2 * var(--variant-borderWidth) - var(--Input-decorator-childHeight)) / 2), var(--Input-paddingInline))',
    '--_Input-paddingBlock': 'max((var(--Input-minHeight) - 2 * var(--variant-borderWidth) - var(--Input-decorator-childHeight)) / 2, 0px)',
    '--Input-decorator-childRadius': 'max(var(--Input-radius) - var(--_Input-paddingBlock), min(var(--_Input-paddingBlock) / 2, var(--Input-radius) / 2))',
    '--Button-minHeight': 'var(--Input-decorator-childHeight)',
    '--IconButton-size': 'var(--Input-decorator-childHeight)',
    '--Button-radius': 'var(--Input-decorator-childRadius)',
    '--IconButton-radius': 'var(--Input-decorator-childRadius)',
    boxSizing: 'border-box',
    minWidth: 0,
    minHeight: 'var(--Input-minHeight)'
  }, ownerState.fullWidth && {
    width: '100%'
  }, {
    cursor: 'text',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    paddingInline: `var(--Input-paddingInline)`,
    borderRadius: 'var(--Input-radius)',
    fontFamily: theme.vars.fontFamily.body,
    fontSize: theme.vars.fontSize.md
  }, ownerState.size === 'sm' && {
    fontSize: theme.vars.fontSize.sm
  }, {
    // TODO: discuss the transition approach in a separate PR. This value is copied from mui-material Button.
    transition: 'border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '&:before': {
      boxSizing: 'border-box',
      content: '""',
      display: 'block',
      position: 'absolute',
      pointerEvents: 'none',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 1,
      borderRadius: 'inherit',
      margin: 'calc(var(--variant-borderWidth) * -1)' // for outlined variant
    }
  }), (0,esm_extends/* default */.Z)({}, variantStyle, {
    backgroundColor: (_variantStyle$backgro = variantStyle == null ? void 0 : variantStyle.backgroundColor) != null ? _variantStyle$backgro : theme.vars.palette.background.surface,
    [`&:hover:not(.${Input_inputClasses.focused})`]: (0,esm_extends/* default */.Z)({}, (_theme$variants2 = theme.variants[`${ownerState.variant}Hover`]) == null ? void 0 : _theme$variants2[ownerState.color], {
      backgroundColor: null,
      // it is not common to change background on hover for Input
      cursor: 'text'
    }),
    [`&.${Input_inputClasses.disabled}`]: (_theme$variants3 = theme.variants[`${ownerState.variant}Disabled`]) == null ? void 0 : _theme$variants3[ownerState.color],
    [`&.${Input_inputClasses.focused}`]: {
      '&:before': {
        boxShadow: `inset 0 0 0 var(--Input-focusedThickness) var(--Input-focusedHighlight)`
      }
    }
  })];
});
const StyledInputHtml = (0,styled/* default */.Z)('input')({
  border: 'none',
  // remove the native input width
  minWidth: 0,
  // remove the native input width
  outline: 0,
  // remove the native input outline
  padding: 0,
  // remove the native input padding
  flex: 1,
  alignSelf: 'stretch',
  color: 'inherit',
  backgroundColor: 'transparent',
  fontFamily: 'inherit',
  fontSize: 'inherit',
  fontStyle: 'inherit',
  fontWeight: 'inherit',
  lineHeight: 'inherit',
  textOverflow: 'ellipsis',
  '&:-webkit-autofill': {
    WebkitBackgroundClip: 'text',
    // remove autofill background
    WebkitTextFillColor: 'currentColor'
  },
  '&::-webkit-input-placeholder': {
    color: 'var(--Input-placeholderColor)',
    opacity: 'var(--Input-placeholderOpacity)'
  },
  '&::-moz-placeholder': {
    // Firefox 19+
    color: 'var(--Input-placeholderColor)',
    opacity: 'var(--Input-placeholderOpacity)'
  },
  '&:-ms-input-placeholder': {
    // IE11
    color: 'var(--Input-placeholderColor)',
    opacity: 'var(--Input-placeholderOpacity)'
  },
  '&::-ms-input-placeholder': {
    // Edge
    color: 'var(--Input-placeholderColor)',
    opacity: 'var(--Input-placeholderOpacity)'
  }
});
const StyledInputStartDecorator = (0,styled/* default */.Z)('span')(({
  theme,
  ownerState
}) => {
  var _theme$variants4, _theme$variants5, _theme$variants6, _theme$variants7;
  return (0,esm_extends/* default */.Z)({
    '--Button-margin': '0 0 0 calc(var(--Input-decorator-childOffset) * -1)',
    '--IconButton-margin': '0 0 0 calc(var(--Input-decorator-childOffset) * -1)',
    '--Icon-margin': '0 0 0 calc(var(--Input-paddingInline) / -4)',
    display: 'inherit',
    alignItems: 'center',
    paddingBlock: 'var(--unstable_Input-paddingBlock)',
    // for wrapping Autocomplete's tags
    flexWrap: 'wrap',
    // for wrapping Autocomplete's tags
    marginInlineEnd: 'var(--Input-gap)',
    color: theme.vars.palette.text.tertiary,
    cursor: 'initial'
  }, ownerState.focused && {
    color: (_theme$variants4 = theme.variants[ownerState.variant]) == null ? void 0 : (_theme$variants5 = _theme$variants4[ownerState.color]) == null ? void 0 : _theme$variants5.color
  }, ownerState.disabled && {
    color: (_theme$variants6 = theme.variants[`${ownerState.variant}Disabled`]) == null ? void 0 : (_theme$variants7 = _theme$variants6[ownerState.color]) == null ? void 0 : _theme$variants7.color
  });
});
const StyledInputEndDecorator = (0,styled/* default */.Z)('span')(({
  theme,
  ownerState
}) => {
  var _theme$variants8, _theme$variants9, _theme$variants10, _theme$variants11;
  return (0,esm_extends/* default */.Z)({
    '--Button-margin': '0 calc(var(--Input-decorator-childOffset) * -1) 0 0',
    '--IconButton-margin': '0 calc(var(--Input-decorator-childOffset) * -1) 0 0',
    '--Icon-margin': '0 calc(var(--Input-paddingInline) / -4) 0 0',
    display: 'inherit',
    alignItems: 'center',
    marginInlineStart: 'var(--Input-gap)',
    color: (_theme$variants8 = theme.variants[ownerState.variant]) == null ? void 0 : (_theme$variants9 = _theme$variants8[ownerState.color]) == null ? void 0 : _theme$variants9.color,
    cursor: 'initial'
  }, ownerState.disabled && {
    color: (_theme$variants10 = theme.variants[`${ownerState.variant}Disabled`]) == null ? void 0 : (_theme$variants11 = _theme$variants10[ownerState.color]) == null ? void 0 : _theme$variants11.color
  });
});
const InputRoot = (0,styled/* default */.Z)(StyledInputRoot, {
  name: 'JoyInput',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({});
const InputInput = (0,styled/* default */.Z)(StyledInputHtml, {
  name: 'JoyInput',
  slot: 'Input',
  overridesResolver: (props, styles) => styles.input
})({});
const InputStartDecorator = (0,styled/* default */.Z)(StyledInputStartDecorator, {
  name: 'JoyInput',
  slot: 'StartDecorator',
  overridesResolver: (props, styles) => styles.startDecorator
})({});
const InputEndDecorator = (0,styled/* default */.Z)(StyledInputEndDecorator, {
  name: 'JoyInput',
  slot: 'EndDecorator',
  overridesResolver: (props, styles) => styles.endDecorator
})({});
const Input = /*#__PURE__*/react.forwardRef(function Input(inProps, ref) {
  var _ref, _inProps$error, _ref2, _inProps$size, _ref3, _inProps$color;
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'JoyInput'
  });
  const _useForwardedInput = useForwardedInput(props, Input_inputClasses),
    {
      propsToForward,
      rootStateClasses,
      inputStateClasses,
      getRootProps,
      getInputProps,
      component,
      componentsProps = {},
      formControl,
      focused,
      error: errorProp = false,
      disabled,
      fullWidth = false,
      size: sizeProp = 'md',
      color: colorProp = 'neutral',
      variant = 'outlined',
      startDecorator,
      endDecorator
    } = _useForwardedInput,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(_useForwardedInput, Input_excluded);
  if (false) {}
  const error = (_ref = (_inProps$error = inProps.error) != null ? _inProps$error : formControl == null ? void 0 : formControl.error) != null ? _ref : errorProp;
  const size = (_ref2 = (_inProps$size = inProps.size) != null ? _inProps$size : formControl == null ? void 0 : formControl.size) != null ? _ref2 : sizeProp;
  const color = error ? 'danger' : (_ref3 = (_inProps$color = inProps.color) != null ? _inProps$color : formControl == null ? void 0 : formControl.color) != null ? _ref3 : colorProp;
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    fullWidth,
    color,
    disabled,
    error,
    focused,
    size,
    variant
  });
  const classes = useUtilityClasses(ownerState);
  const rootProps = (0,useSlotProps/* default */.Z)({
    elementType: InputRoot,
    getSlotProps: getRootProps,
    externalSlotProps: componentsProps.root,
    externalForwardedProps: other,
    additionalProps: {
      ref,
      as: component
    },
    ownerState,
    className: [classes.root, rootStateClasses]
  });
  const inputProps = (0,useSlotProps/* default */.Z)({
    elementType: InputInput,
    getSlotProps: otherHandlers => getInputProps((0,esm_extends/* default */.Z)({}, otherHandlers, propsToForward)),
    externalSlotProps: componentsProps.input,
    ownerState,
    additionalProps: formControl ? {
      id: formControl.htmlFor,
      'aria-describedby': formControl['aria-describedby']
    } : {},
    className: [classes.input, inputStateClasses]
  });
  const startDecoratorProps = (0,useSlotProps/* default */.Z)({
    elementType: InputStartDecorator,
    externalSlotProps: componentsProps.startDecorator,
    ownerState,
    className: classes.startDecorator
  });
  const endDecoratorProps = (0,useSlotProps/* default */.Z)({
    elementType: InputEndDecorator,
    externalSlotProps: componentsProps.endDecorator,
    ownerState,
    className: classes.endDecorator
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(InputRoot, (0,esm_extends/* default */.Z)({}, rootProps, {
    children: [startDecorator && /*#__PURE__*/(0,jsx_runtime.jsx)(InputStartDecorator, (0,esm_extends/* default */.Z)({}, startDecoratorProps, {
      children: startDecorator
    })), /*#__PURE__*/(0,jsx_runtime.jsx)(InputInput, (0,esm_extends/* default */.Z)({}, inputProps)), endDecorator && /*#__PURE__*/(0,jsx_runtime.jsx)(InputEndDecorator, (0,esm_extends/* default */.Z)({}, endDecoratorProps, {
      children: endDecorator
    }))]
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Input_Input = (Input);

/***/ }),

/***/ 57579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useId; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

let globalId = 0;
function useGlobalId(idOverride) {
  const [defaultId, setDefaultId] = react__WEBPACK_IMPORTED_MODULE_0__.useState(idOverride);
  const id = idOverride || defaultId;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (defaultId == null) {
      // Fallback to this default id when possible.
      // Use the incrementing value for client-side rendering only.
      // We can't use it server-side.
      // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
      globalId += 1;
      setDefaultId(`mui-${globalId}`);
    }
  }, [defaultId]);
  return id;
}

// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const maybeReactUseId = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useId' + ''];
/**
 *
 * @example <div id={useId()} />
 * @param idOverride
 * @returns {string}
 */
function useId(idOverride) {
  if (maybeReactUseId !== undefined) {
    const reactId = maybeReactUseId();
    return idOverride != null ? idOverride : reactId;
  }
  // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
  return useGlobalId(idOverride);
}

/***/ })

}]);